import React, { Component } from 'react';
import { connect } from 'react-redux';
import style from './style.css';
import CSSModule from 'react-css-modules';
import { Link } from 'react-router';
import $ from 'jquery';
import cookie from 'react-cookie';
import moment from 'moment';
import { browserHistory } from 'react-router';

import { getStudents, getClassList, changeClassSingupStatus, cancelFixedSignUp } from '../../actions';

import Button from '../../component/button';
import Title from '../../component/title';
import { Calendar, Modal } from 'antd';
import Board from './board';

const studentStatusMap = {
	"non-arrival": "還未上課",
}

const classStatusMap = {
	"as-usual": "照常上課",
}



class ApplyMain extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dayClassMap: {}
		}
		this.handleClick = (e) => {
		}

		this.cancelFixed = (signup_id, callback) => {
			this.props.cancelFixedSignUp({ signup_id }).then(( res )=>{
				callback(res);
			})

			// callback({ count: 4});
		}

		this.changeStatus = (signup_id, action, callback) => {

			//console.log("123123123123");

			this.props.changeClassSingupStatus({
				signup_id: signup_id,
				action: action
			}).then((res) => {
				callback(res);
			})

		}

		this.onSelect = (date) => {
			const selectedDay = moment(date).format("MMDD");
			const info = this.state.dayClassMap["D-"+selectedDay];
			let BoardArr = [];
			const renderInfo = () => {
				for( var key in info ) {
					BoardArr.push( <Board key={key} data={info[key]} changeStatus={this.changeStatus} cancelFixed={this.cancelFixed}/> );
				}
				return BoardArr.sort((a,b)=>{
					try{
						var timeA = moment(a.props.data.class_lesson.start_time);
						var timeB = moment(b.props.data.class_lesson.start_time);
					}catch(e) {
						return false;
					}
					if(!a || !b || !timeA || !timeB ) return false;
					return timeA.diff(timeB);
				});
			}

			//console.log(info);
			if( info ) {

				Modal.info({
					title: `報名管理`,
					content: renderInfo(),
					maskClosable: true
				})
			}
			

			//console.log(date.date());
		}
		this.onPanelChange = ( date, mode) => {
			//console.log(date.format("YYYY-MM"));
			this.setState({ dayClassMap: {}});
			this.props.getStudents({ now: date }).then((res) => {
				this.setState({
					dayClassMap: this._getMonthClassData(res)
				})
			});
		}
		this.dateCellRender = (value) => {
			const listData = this._getListData(value);
			let dayArr = [];
			const renderListData = (object) => {
				for( let key in object) {
					const time = moment(object[key].class_lesson.start_time).format("HH:mm");
					dayArr.push(
						<li key={key} sort={time.slice(0,2)}>
							<span  style={ {textDecoration : (object[key].class_lesson.status === 'as-usual') ? 'none' : 'line-through'} } >
								{time}
								{object[key].class.short_title || object[key].class.title}
							</span>
							{(object[key].class_lesson.status === 'as-usual') ? '' : '(停課)'}
							{(object[key].status === 'absence') ? '(請假)' : ''}
						</li>
					)
				}
				
				return dayArr.sort((a,b)=>{
					if(!a || !b ) return false;
					return a.props.sort - b.props.sort;
				});

			}
			return (
			<ul className="events">
				{
					renderListData(listData)
				}
			</ul>
			);
		}
	}   
	componentDidMount() {
		this.props.getStudents({ now: moment()}).then((res)=>{
			this.setState({
				dayClassMap: this._getMonthClassData(res)
			})
		})
	}
	componentWillMount() {
		if(this.props.params && this.props.params.amt) {
			window.ga('send', 'event', 'transaction', 'purchase', '', this.props.params.amt);
			alert('購買成功，感謝您，期待您來教室上課！');
			browserHistory.replace('/applyMain');
		}
	}
	render() {
		const { lessons, step, dayClassMap } = this.state;
		const { lastPoints } = this.props;
		//console.log(dayClassMap);

		$(".ant-fullcalendar-cell").off("click");

		$(".ant-fullcalendar-next-month-btn-day").click((e)=>{
			e.stopPropagation();
		})
		$(".ant-fullcalendar-last-month-cell").click((e)=>{
			e.stopPropagation();
		})

		return (
			<div>
				<div styleName="banner">
					<div styleName="welcome">歡迎使用武林文創，您有 { lastPoints } 點服務點數。</div>
					<Link to="/applyExp"><Button styleName="button">報名活動或課程單堂課</Button></Link>
					<Link to="/applyFixed"><Button styleName="button">報名班級固定生</Button></Link>
				</div>
				<div styleName="calandar">
					<Title>我的課程表</Title>
					<Calendar  dateCellRender={this.dateCellRender} onSelect={this.onSelect} onPanelChange={this.onPanelChange}/>
				</div>
			</div>
		);
	}
	_getMonthClassData(result) {
		//console.log(result);
		let dayClassMap = {}

		for ( var i=0; i< result.length; i++ ) {

			let signUps = result[i].sign_ups;

			if( signUps && signUps.length > 0 ) {
				
				for( var j=0; j< signUps.length; j++ ) {
					let hasClassDay = moment(signUps[j].class_lesson.start_time).format("MMDD");

					dayClassMap["D-"+hasClassDay] = dayClassMap["D-"+hasClassDay] || {};
					
					let lesson_id = signUps[j].class_lesson.id;

					if( dayClassMap["D-"+hasClassDay]["L-"+lesson_id] ) {
						dayClassMap["D-"+hasClassDay]["L-"+lesson_id].students.push({
							type: signUps[j].type,
							student_name: result[i].name,
							signUps_id: signUps[j].id,
							student_id: result[i].id,
							status: signUps[j].status
						})
					}else {
						dayClassMap["D-"+hasClassDay]["L-"+lesson_id] = {
							content: signUps[j].class.title,
							class: signUps[j].class,
							class_lesson: signUps[j].class_lesson,
							status: signUps[j].status,
							students: [{
								type: signUps[j].type,
								student_name: result[i].name,
								signUps_id: signUps[j].id,
								student_id: result[i].id,
								status: signUps[j].status
							}]
						}
						// //console.log(classDayInfo["L-"+lesson_id]);
					} 
				}
				 
				// dayClassMap["D-"+hasClassDay].student_name.push(result[i].name);
				// dayClassMap["D-"+hasClassDay].student_id.push(result[i].id);
			}
		}
		return dayClassMap;
	}
	
	_getListData(value) {
		let listData;

		listData = this.state.dayClassMap["D-"+moment(value).format("MMDD")];

		return listData || {};
	}
}

const mapStateToProps = state => {
	return {
		lastPoints: state.data.lastPoints
	};
}

export default connect(mapStateToProps, { getStudents, getClassList, changeClassSingupStatus, cancelFixedSignUp })(CSSModule(ApplyMain,style,{allowMultiple:true}));




/** WEBPACK FOOTER **
 ** ./src/container/applyMain/index.js
 **/